import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";
import { Dropdown } from "react-bootstrap";
import InputBox from "elements/InputBox";
import { isMobile, isMobileByViewPort } from "services/isMobile";

/** Readable label for kebab-case API names (e.g. groove-betsolutions → Groove Betsolutions). */
function formatProviderLabel(raw) {
  if (raw == null || String(raw).trim() === "") return "";
  const s = String(raw).trim();
  if (!/[-_]/.test(s)) return s;
  return s
    .split(/[-_]+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

const ProviderFilterDropdown = (props) => {
  const [searchProvider, setSearchProvider] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [providers, setProviders] = useState([]);
  const selectedProviders = props.selectedProviders;
  const setSelectedProviders = props.setSelectedProviders;

  const toggleSelectedProvider = (providerId) => {
    var providersClone = JSON.parse(JSON.stringify(selectedProviders));
    if (providersClone.indexOf(providerId) === -1) {
      providersClone.push(providerId);
    } else {
      providersClone.splice(providersClone.indexOf(providerId), 1);
    }

    setSelectedProviders(providersClone);

    // On mobile devices, close the dropdown after selection
    if (isMobile() || isMobileByViewPort()) {
      setIsDropdownOpen(false);
    }
    // On desktop, keep dropdown open for multiple selections
  };

  const providersList = Array.isArray(props.providers) ? props.providers : [];

  const handleSearch = (str) => {
    if (str === "" || str === null || str === undefined) {
      setProviders(providersList);
    } else {
      const result = providersList.filter((provider) =>
        (provider?.name ?? "").toLowerCase().includes(str.toLowerCase())
      );
      setProviders(result);
    }
  };

  useEffect(() => {
    setProviders(providersList);
  }, [props.providers]);

  // Handle search when searchProvider changes
  useEffect(() => {
    handleSearch(searchProvider);
  }, [searchProvider]);

  /** Keep wheel/trackpad scroll inside the menu so the page does not scroll (scroll chaining). */
  const stopWheelBubble = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <>
      <Dropdown
        className="gameProviderDropdown"
        show={isDropdownOpen}
        onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
      >
        <Dropdown.Toggle
          className="providerBtn"
          variant="success"
          id="dropdown-basic"
        >
          <span className="providerBtn__label">{__("Providers")}</span>
          <span className="providerBtn__meta">
            {selectedProviders.length > 0 ? (
              <span className="countNum">{selectedProviders.length}</span>
            ) : null}
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="providerLists"
          onWheel={stopWheelBubble}
        >
          <div className="providerLists__search">
            <div className="input_item">
              <InputBox
                className="form-control name_value providerLists__searchInput"
                value={searchProvider}
                onChange={(value) => {
                  setSearchProvider(value);
                  handleSearch(value);
                }}
                type="text"
                placeholder={__("Search")}
              />
            </div>
          </div>

          <div className="providerLists__scroll" onWheel={stopWheelBubble}>
            {providers.map((item) => (
              <div className="providerLists__row" key={item.provider_id}>
                <label htmlFor={item.provider_id}>
                  <input
                    checked={
                      selectedProviders.indexOf(item.provider_id) !== -1
                    }
                    id={item.provider_id}
                    type="checkbox"
                    onChange={() => {
                      toggleSelectedProvider(item.provider_id);
                    }}
                  />

                  <div className="checkboxDesign"></div>
                  <div className="checkboxText" title={item.name}>
                  {formatProviderLabel(item.name)}
                </div>
                  <div className="gameCount">
                    {item.gameCount ?? item.game_count ?? "—"}
                  </div>
                </label>
              </div>
            ))}
          </div>

          <Link
            hreflang={Translator.getSelectedLanguage().code}
            onClick={() => {
              setSelectedProviders([]);
              if (isMobile() || isMobileByViewPort()) {
                setIsDropdownOpen(false);
              }
            }}
            className="clearListBtn"
          >
            {__("Clear Lists")}
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
export default ProviderFilterDropdown;
